module.exports = __webpack_public_path__ + "img/icon-letter-b.6624b0e5.svg";